module.exports = __webpack_public_path__ + "static/media/carrito.b0d33964.svg";